import React from 'react';

const SummerBackgroundGraphics = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden select-none">
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(circle at 50% 25%, rgba(234, 179, 8, 0.22) 0%, rgba(249, 115, 22, 0.16) 40%, transparent 70%), radial-gradient(circle at 80% 80%, rgba(6, 182, 212, 0.14) 0%, transparent 60%)'
        }}
      />

      <svg viewBox="0 0 1600 1000" className="w-full h-full object-cover" preserveAspectRatio="xMidYMid slice">
        <defs>
          <radialGradient id="summerSun" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#FEF08A" />
            <stop offset="60%" stopColor="#F59E0B" />
            <stop offset="100%" stopColor="#EA580C" />
          </radialGradient>
          <filter id="sunHalo" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="8" />
          </filter>
        </defs>

        {/* Blazing Tropical Sun Horizon */}
        <circle cx="800" cy="460" r="100" fill="url(#summerSun)" filter="url(#sunHalo)" opacity="0.5" />
        <circle cx="800" cy="460" r="90" fill="url(#summerSun)" />

        {/* Swaying Coconut Palm Fronds (Framing edges) */}
        <g stroke="#163852" strokeWidth="4" strokeLinecap="round" fill="none">
          <path d="M0,580 Q80,420 160,380 M160,380 Q220,350 280,360 M160,380 Q240,400 270,440" />
          <path d="M1600,560 Q1520,410 1440,370 M1440,370 Q1380,340 1320,350 M1440,370 Q1360,390 1330,430" />
        </g>

        {/* Ocean Waves Contour */}
        <path d="M0 640 Q400 620 800 635 T1600 630 L1600 1000 L0 1000 Z" fill="#0A2235" />
        <path d="M0 720 Q500 700 1000 715 T1600 710 L1600 1000 L0 1000 Z" fill="#071927" />
        <path d="M0 820 Q400 800 800 815 T1600 810 L1600 1000 L0 1000 Z" fill="#04101A" />
      </svg>
    </div>
  );
};

export default SummerBackgroundGraphics;
